<template>
  <label :class="{'spl-checkbox-group__item__label-checked': isChecked, 'spl-checkbox-group__item__label-margin': hasMargin}" class="spl-checkbox-group__item__label">
    <input
      :name="name"
      :value="value"
      :checked="isChecked"
      :disabled="disabled"
      :tabindex="tabindex"
      class="spl-checkbox"
      type="checkbox"
      @change="checkboxChanged">
    <span v-if="hasDefaultSlot"><slot /></span>
  </label>
</template>

<script>
export default {
  name: 'FormCheckbox',
  props: [
    'checked',
    'disabled',
    'name',
    'index',
    'value',
    'hasMargin',
    'tabindex'
  ],
  data () {
    return {
      isChecked: this.checked || false
    }
  },
  computed: {
    hasDefaultSlot () {
      return !!this.$slots.default
    }
  },
  watch: {
    checked (newVal, oldVal) {
      this.isChecked = newVal
    }
  },
  methods: {
    checkboxChanged () {
      this.isChecked = !this.isChecked
      this.$emit('checkboxChanged', this.isChecked, this.index)
      this.$emit('input', this.isChecked, this.index)
    }
  }
}
</script>

<style lang="scss">
    @import '../../variables.scss';

    .spl-checkbox {
        background-color: #fff;
        border-radius: 4px;
        cursor: pointer;
        height: 16px;
        margin: 0 5px 0 0;
        transition: all $shortTransition ease-in-out;
        width: 16px;
        &:focus {
          box-shadow: 0 0 0.1em 0.1em rgba(100,100,100,0.5);
        }
        &:checked {
            background-color: $mainInputColor;
            border-color: $mainInputColor;
            position: relative;
        }
        &:disabled {
            content: '';
            height: 16px;
            pointer-events: none;
            width: 16px;

        }

    }
    .spl-checkbox-group {
        margin-bottom: $mainBottomMargin;

        @include mobile() {
            margin: 0;
        }
        &__item {
            padding-top: 10px;
            position: relative;

            .spl-input {
                margin: 0 0 0 30px;
                width: auto;
                position: absolute;
                top: 0;
            }
            &__label {

                &-margin {
                  .spl-checkbox {
                    margin: 5px;
                  }
                  span {
                    margin: 5px;
                  }
                }

                color: $radioLabelText;
                cursor: pointer;
                display: inline-block;
                font-size: 14px;
                vertical-align: top;

                span {
                    display: inline-block;
                    line-height: 16px;
                    vertical-align: top;
                }
            }
        }
    }
</style>
